export const IMAGES = {
  characters: {
    wormy_funky: require('./logos/funky-worm.png'),
    wormy_book3: require('assets/images/logos/wormy-book-3.png'),
    wormy_student: require('assets/images/logos/wormy-student.png'),
    wormy_teacher: require('assets/images/logos/wormy-teacher.png'),
    wormy_pointing: require('assets/images/logos/wormy-you.png'),
    wormy_apple: require('assets/images/logos/wormy-apple.png'),
    wormy_hint: require('assets/images/logos/wormy-hint.png'),
    wormy_arcade: require('assets/images/logos/wormy-arcade.png'),
  },
  logos: {
    orator_white: require('assets/images/logos/orator_white.png'),
    orator_default: require('assets/images/logos/orator_default.png'),
    wormy_green: require('assets/images/logos/wormy_logo_green.png'),
  },
  icons: {
    search_wormy: require('assets/images/logos/wormy-search.png'),
  },
};
